var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBacklogIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.002C5 19 17 19 17 19V16.998C17 17 5 17 5 17V19.002ZM3 16.998C3 15.894 3.895 15 4.994 15H17.006C18.107 15 19 15.898 19 16.998V19.002C19.0003 19.5313 18.7904 20.039 18.4165 20.4137C18.0426 20.7883 17.5353 20.9992 17.006 21H4.994C4.46479 20.9989 3.95762 20.788 3.58379 20.4134C3.20995 20.0388 3 19.5312 3 19.002V16.998Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15H17V13H5V15ZM3 11H19V17H3V11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.002C7 11 19 11 19 11V8.998C19 9 7 9 7 9V11.002ZM5 8.998C5 7.894 5.895 7 6.994 7H19.006C20.107 7 21 7.898 21 8.998V11.002C21.0003 11.5313 20.7904 12.039 20.4165 12.4137C20.0426 12.7883 19.5353 12.9992 19.006 13H6.994C6.46479 12.9989 5.95762 12.788 5.58379 12.4134C5.20995 12.0388 5 11.5312 5 11.002V8.998Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5V7H17V5H5ZM3 4.998C3 3.894 3.895 3 4.994 3H17.006C18.107 3 19 3.898 19 4.998V9H3V4.998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacklogIcon);
export default __webpack_public_path__ + "static/media/BacklogIcon.44946f7b0bb8aea0cf921f600e3add34.svg";
export { ForwardRef as ReactComponent };